var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4016 7.99998C14.4016 11.5346 11.5362 14.4 8.00156 14.4C4.46694 14.4 1.60156 11.5346 1.60156 7.99998C1.60156 4.46535 4.46694 1.59998 8.00156 1.59998C11.5362 1.59998 14.4016 4.46535 14.4016 7.99998ZM10.0016 5.99998C10.0016 7.10454 9.10613 7.99998 8.00156 7.99998C6.89699 7.99998 6.00156 7.10454 6.00156 5.99998C6.00156 4.89541 6.89699 3.99998 8.00156 3.99998C9.10613 3.99998 10.0016 4.89541 10.0016 5.99998ZM8.00156 9.59998C6.43463 9.59998 5.04306 10.3508 4.16699 11.5123C5.11763 12.5496 6.48364 13.2 8.00156 13.2C9.51948 13.2 10.8855 12.5496 11.8361 11.5123C10.9601 10.3508 9.5685 9.59998 8.00156 9.59998Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconFilled);
export default __webpack_public_path__ + "static/media/UserIconFilled.3148f9fc2b3511f7c77cd43752677df6.svg";
export { ForwardRef as ReactComponent };